<template>
  <div
    class="page-header flex flex-row px-6 items-center justify-between md:mb-6 mb-8 py-4 w-full border-b"
  >
    <h1 class="text-2xl text-font-950 font-bold">
      {{ props.title }}
    </h1>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  title: string
}>()
</script>
